import { createFileRoute } from "@tanstack/react-router";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { EditProfileTemplate } from "~/features/myProfile/EditProfileTemplate";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる。
// 中身は PageContainer（min-h-screen・自前スクロールなし）でページスクロール前提のため、
// fixed の overlay 自体を overflow-y-auto でスクロール可能にする（長いフォームの下部が到達不能になるのを防ぐ）。
const EditPage = () => (
  <div className="fixed inset-0 z-40 overflow-y-auto overscroll-contain bg-white">
    <EditProfileTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/edit")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(myProfileQueryOptions),
  component: EditPage,
});
